import { useEffect } from 'react';

import { useSelectedProductTypes } from '~src/hooks/useSelectedProductTypes';
import { useTakeover } from '~src/hooks/useTakeover';
import { DeepPartial, HeatPumpOutdoorUnit, ProductTypes, Residence } from '~src/model';

export const useAvailableProductTypes = (
  residence?: DeepPartial<Residence>,
  outdoorUnits?: HeatPumpOutdoorUnit[],
  allowedProductTypes: ProductTypes = ['heatPump', 'solar']
) => {
  const { selectedProductTypes, setSelectedProductTypes } = useSelectedProductTypes(allowedProductTypes);

  const solarTakeover = useTakeover(residence, outdoorUnits, ['solar']);
  const heatPumpTakeover = useTakeover(residence, outdoorUnits, ['heatPump']);

  useEffect(
    function setDefaultFilter() {
      if (!solarTakeover && allowedProductTypes.includes('solar')) {
        setSelectedProductTypes(['solar']);
        return;
      }

      setSelectedProductTypes(allowedProductTypes);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [heatPumpTakeover, solarTakeover]
  );

  useEffect(
    function overrideFilter() {
      if (selectedProductTypes.length > allowedProductTypes.length) {
        setSelectedProductTypes(allowedProductTypes);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedProductTypes, allowedProductTypes]
  );

  return {
    selectedProductTypes: selectedProductTypes ?? [],
    setSelectedProductTypes,
    heatPumpTakeover,
    solarTakeover,
  };
};
